export default __webpack_public_path__ + "static/banner-2-f20b0255b124495a7e0e53580d791ebc.png";